import React, { useState } from "react";
import { Typography, Box, Grid } from "@mui/material";
import InfoIcon from "../../src/assets/icons/InfoIcon.png";

import "./styles/common.scss";

const InfoCapsule = (props) => {
  const {
    color,
    width,
    margin,
    minWidth,
    click,
    padding,
    border,
    borderRadius,
    fontSize,
    fontWeight,
    bgColor,
    title,
    info,
    textAlign,
    disabled = false,
  } = props;
  const [showInfoBox, setShowInfoBox] = useState(false);
  return (
    <Box component="div" position="relative">
      <Grid
        container
        sx={{
          color: color ? color : "color.dimGrey",
          padding: padding ? padding : "0.5rem 0.8rem",
          border: border ? border : "none",
          borderRadius: borderRadius ? borderRadius : 10,
          margin: margin ? margin : "0.3rem",
          bgcolor: bgColor ? bgColor : "color.lightGrey",
          width: width ? width : "300px",
          minWidth: minWidth ? minWidth : "200px",
          cursor: "pointer",
          "&:hover": {
            border: border ? border : "none",
          },
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? "none" : "all",
          position: "relative",
        }}
        onClick={click}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="p"
            sx={{
              textAlign: textAlign ? textAlign : "left",
              fontWeight: fontWeight ? fontWeight : "400",
              fontSize: fontSize ? fontSize : "0.78rem",
            }}
          >
            {title}
          </Typography>
        </Grid>
        {/* <Box
          component="div"
          sx={{
            position: "absolute",
            right: 10,
            marginTop: "-2px",
          }}
          onMouseOver={() => setShowInfoBox(true)}
          onMouseOut={() => setShowInfoBox(false)}
        > */}
        <img
          src={InfoIcon}
          style={{
            width: "15px",
            position: "absolute",
            right: 10,
            top: 15,
          }}
          onMouseOver={() => setShowInfoBox(true)}
          onMouseOut={() => setShowInfoBox(false)}
        />
        {/* </Box> */}
      </Grid>
      <Box
        component="div"
        position="absolute"
        display={showInfoBox ? "block" : "none"}
        className="tooltip-container"
      >
        <Typography fontSize="12px">{info}</Typography>
      </Box>
    </Box>
  );
};

export default InfoCapsule;
